<template>
  <div class="content content-az">
    <span>{{ welcome }}</span>
    <span>
      <span class="sysName">{{ sysName }}</span>
      <span>{{ title }}</span>
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      welcome: "欢迎使用",
      sysName: "这里运动",
      title: "管理系统",
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > span {
    display: block;
    font-size: 58px;
    .sysName {
      color: #50d6ff;
    }
  }
}
</style>
